import { Factory, GlobeHemisphereWest, Lightbulb, Rocket, type Icon } from '@phosphor-icons/react';

import './index.less';

interface Metric {
  value: string;
  suffix: string;
  label: string;
}

interface CoreValue {
  title: string;
  desc: string;
  icon: Icon;
  accent: 'blue' | 'cyan' | 'amber' | 'violet';
}

const METRICS: Metric[] = [
  { value: '12k', suffix: '+', label: '智能体' },
  { value: '1600w', suffix: '+', label: '调用量' },
  { value: '1w', suffix: '+', label: '智能体构建师' },
];

const CORE_VALUES: CoreValue[] = [
  {
    title: '技术革新',
    desc: '持续探索 AI 技术边界，把先进算法落到真实创作场景。',
    icon: Rocket,
    accent: 'blue',
  },
  {
    title: '自主研发',
    desc: '以自研能力驱动产品迭代，构建自动化视频生产链路。',
    icon: Lightbulb,
    accent: 'cyan',
  },
  {
    title: '工业化 2.0',
    desc: '推动视频制作走向标准化、规模化与智能化。',
    icon: Factory,
    accent: 'amber',
  },
  {
    title: '全球视野',
    desc: '为全球创作者提供高效、精准、可扩展的视频方案。',
    icon: GlobeHemisphereWest,
    accent: 'violet',
  },
];

const TrustSection = () => {
  return (
    <section className="home-trust" id="values">
      <div className="home-trust__backdrop" aria-hidden>
        <span className="home-trust__grid" />
        <span className="home-trust__orb home-trust__orb--1" />
        <span className="home-trust__orb home-trust__orb--2" />
      </div>

      <div className="container home-trust__inner">
        <header className="home-trust__head">
          <span className="home-trust__eyebrow">关于我们</span>
          <h2 className="home-trust__title">
            坚守品质与稳定，<span className="home-trust__title-keep">不负每一份信赖</span>
          </h2>
          <p className="home-trust__desc">
            日益增多的智能体开发者选择我们的插件，品质、稳定、及时响应这三大支柱是我们稳固的基石。
          </p>
        </header>

        <div className="home-trust__metrics">
          {METRICS.map((metric) => (
            <div className="home-trust__metric" key={metric.label}>
              <div className="home-trust__metric-value">
                {metric.value}
                <span className="home-trust__metric-suffix">{metric.suffix}</span>
              </div>
              <div className="home-trust__metric-label">{metric.label}</div>
            </div>
          ))}
        </div>

        <div className="home-trust__values">
          {CORE_VALUES.map(({ title, desc, icon: ValueIcon, accent }) => (
            <article className={`home-trust-value home-trust-value--${accent}`} key={title}>
              <span className="home-trust-value__icon">
                <ValueIcon size={22} weight="fill" aria-hidden />
              </span>
              <h3 className="home-trust-value__title">{title}</h3>
              <p className="home-trust-value__desc">{desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
